// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__jJFF8","title":"ClientCherryInfo_title__2RgI3","itemText":"ClientCherryInfo_itemText__3RbvH"};